
import Vue from 'vue'
import { originOptions } from '@/scripts/data'
export default Vue.extend({
  name: 'SelectOrigin',
  props: ['selectDefault', 'id'],
  data: function () {
    return {
      dataOriginOptions: originOptions
    }
  }
})
